import React, {useState} from 'react';
import axios from "axios";
            
const ContactSearch = (props) => {
    const [searchValue, setSearchValue] = useState("");
    const [searchData, setSearchData] = useState("");
    const [searchError, setSearchError] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);

    const hostName = (window.location.hostname .indexOf("minikube") > -1) ? "sp.minikube.local" : window.location.hostname;
    const searchUrl = `${window.location.protocol}//${hostName}/sp/services/search?q=${searchValue}&lg=${nortonAnalytics.site_language}&ct${nortonAnalytics.site_country}`;

    const fetchData = async () => {
        try {
            // Clear curated topics and any previous search error messaging
            props.updateIntent("other");
            clearSearchError();

            // Get search results from the API
            const res = await axios.get(`${searchUrl}`, { headers: { Accept: "application/json" } });
            setSearchData(res.data.results);

            // Analytics: Fire event31 when search results are returned.
            s.events = "event31";
            s.tl();

            // Scroll to the top of the self help cx
            document.getElementById("self-help").scrollIntoView();

        } catch (err) {
            setSearchError(true);
            setSubmitClicked(false);
        }
    }

    const clearSearchError = () => {
        setSearchError(false);
    }

    const handleSearch = (e) => {
        e.preventDefault();        

        // Reset Search Data on repeat searches
        setSearchData("");

        // Show Spinner
        setSubmitClicked(true);

        // Analytics: Fire event30 and set eVar40 when search is performed. 
        s.events = "event30";
        s.eVar40 = searchValue;
        s.tl();

        fetchData().then(() => {
            setSubmitClicked(false);
        });
    }

    return (
        <div id="contact-search">

            { submitClicked &&
                <div id="contact-spinner" className="text-center mt-3 mb-3"><img src="https://support.norton.com/sp/static/external/assets/images/vulcan/symassets/northstar-v2-loading-spinner.gif"/></div>
            }

            { searchData && (
                <div id="contact-search-topics">
                    <div class="contact-subheader contact-pt-10 contact-pb-25">{props.contentStrings['review-search-subheader']}</div>
                    {searchData.map((searchResult) => 
                        <div class="contact-search-topic" key={searchResult.key}>
                            <a href={`${props.relativeUrl}/solutions/${searchResult.linkTarget}`}>{searchResult.title}</a>
                            <div class="contact-search-topic-abstract">{searchResult.abstract}</div>
                        </div>
                    )}
                </div>
            )}

            <form role="form" id="contact-search-form" onSubmit={handleSearch}>
                <div className="form-group">
                    <input id="contact-search-input" type="text" placeholder={props.contentStrings['review-search']} onFocus={clearSearchError} onChange={(e) => setSearchValue(e.target.value)}/>
                    <input id="contact-search-submit" className="btn btn-default input-lg" type="image" src="https://support.norton.com/sp/images/icn_search.png" border="0" alt="Submit"/>
                    {searchError && (<span className="help-block">{props.contentStrings['review-search-error']}</span>)}
                </div>
            </form>

        </div>
    )   
}

export default ContactSearch